// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HouseholdWorkflowTracker_WorkflowTrackerFragment = { __typename?: 'WorkflowTracker', id: string, status: Types.WorkflowTrackerStatus, kind: Types.WorkflowTrackerKind, failureReason?: string | null, householdID?: string | null, createdAt: Time, updatedAt: Time, startedAt: Time, endedAt?: Time | null, description?: string | null, household?: { __typename?: 'Household', id: string, displayName: string } | null, entities?: Array<{ __typename?: 'Entity', id: string }> | null, testamentaryEntities?: Array<{ __typename?: 'TestamentaryEntity', id: string }> | null, documents?: Array<{ __typename?: 'Document', id: string }> | null, presentation?: { __typename?: 'ClientPresentationV2', id: string } | null, diagramArtifact?: { __typename?: 'DiagramArtifact', id: string } | null, conversation?: { __typename?: 'Conversation', id: string } | null };

export type FetchHouseholdWorkflowTrackerHistoryQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  kinds?: Types.InputMaybe<Array<Types.WorkflowTrackerKind> | Types.WorkflowTrackerKind>;
}>;


export type FetchHouseholdWorkflowTrackerHistoryQuery = { __typename?: 'Query', householdWorkflowTrackerHistory: { __typename?: 'WorkflowTrackerConnection', edges?: Array<{ __typename?: 'WorkflowTrackerEdge', node?: (
        { __typename?: 'WorkflowTracker' }
        & HouseholdWorkflowTracker_WorkflowTrackerFragment
      ) | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null } } };

export type FetchHouseholdSetupHistoryQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type FetchHouseholdSetupHistoryQuery = { __typename?: 'Query', extractionHistory: { __typename?: 'WorkflowTrackerConnection', edges?: Array<{ __typename?: 'WorkflowTrackerEdge', node?: (
        { __typename?: 'WorkflowTracker' }
        & HouseholdWorkflowTracker_WorkflowTrackerFragment
      ) | null } | null> | null }, onboardingHistory: { __typename?: 'WorkflowTrackerConnection', edges?: Array<{ __typename?: 'WorkflowTrackerEdge', node?: (
        { __typename?: 'WorkflowTracker' }
        & HouseholdWorkflowTracker_WorkflowTrackerFragment
      ) | null } | null> | null }, presentationHistory: { __typename?: 'WorkflowTrackerConnection', edges?: Array<{ __typename?: 'WorkflowTrackerEdge', node?: (
        { __typename?: 'WorkflowTracker' }
        & HouseholdWorkflowTracker_WorkflowTrackerFragment
      ) | null } | null> | null }, validationHistory: { __typename?: 'WorkflowTrackerConnection', edges?: Array<{ __typename?: 'WorkflowTrackerEdge', node?: (
        { __typename?: 'WorkflowTracker' }
        & HouseholdWorkflowTracker_WorkflowTrackerFragment
      ) | null } | null> | null } };

export type HouseholdWorkflowTrackerUpdatesSubscriptionVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type HouseholdWorkflowTrackerUpdatesSubscription = { __typename?: 'Subscription', householdWorkflowTrackerUpdates: (
    { __typename?: 'WorkflowTracker' }
    & HouseholdWorkflowTracker_WorkflowTrackerFragment
  ) };

export const Operations = {
  Query: {
    FetchHouseholdWorkflowTrackerHistory: 'FetchHouseholdWorkflowTrackerHistory' as const,
    FetchHouseholdSetupHistory: 'FetchHouseholdSetupHistory' as const
  },
  Subscription: {
    HouseholdWorkflowTrackerUpdates: 'HouseholdWorkflowTrackerUpdates' as const
  },
  Fragment: {
    HouseholdWorkflowTracker_WorkflowTracker: 'HouseholdWorkflowTracker_WorkflowTracker' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const HouseholdWorkflowTracker_WorkflowTrackerFragmentDoc = gql`
    fragment HouseholdWorkflowTracker_WorkflowTracker on WorkflowTracker {
  id
  status
  kind
  failureReason
  householdID
  createdAt
  updatedAt
  startedAt
  endedAt
  description
  household {
    id
    displayName
  }
  entities {
    id
  }
  testamentaryEntities {
    id
  }
  documents {
    id
  }
  presentation {
    id
  }
  diagramArtifact {
    id
  }
  conversation {
    id
  }
}
    `;
export const FetchHouseholdWorkflowTrackerHistoryDocument = gql`
    query FetchHouseholdWorkflowTrackerHistory($householdID: ID!, $first: Int!, $after: Cursor, $kinds: [WorkflowTrackerKind!]) {
  householdWorkflowTrackerHistory(
    householdID: $householdID
    first: $first
    after: $after
    filter: {kinds: $kinds}
  ) {
    edges {
      node {
        ...HouseholdWorkflowTracker_WorkflowTracker
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${HouseholdWorkflowTracker_WorkflowTrackerFragmentDoc}`;

/**
 * __useFetchHouseholdWorkflowTrackerHistoryQuery__
 *
 * To run a query within a React component, call `useFetchHouseholdWorkflowTrackerHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHouseholdWorkflowTrackerHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHouseholdWorkflowTrackerHistoryQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useFetchHouseholdWorkflowTrackerHistoryQuery(baseOptions: Apollo.QueryHookOptions<FetchHouseholdWorkflowTrackerHistoryQuery, FetchHouseholdWorkflowTrackerHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchHouseholdWorkflowTrackerHistoryQuery, FetchHouseholdWorkflowTrackerHistoryQueryVariables>(FetchHouseholdWorkflowTrackerHistoryDocument, withFetchPolicyContext(options));
      }
export function useFetchHouseholdWorkflowTrackerHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchHouseholdWorkflowTrackerHistoryQuery, FetchHouseholdWorkflowTrackerHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchHouseholdWorkflowTrackerHistoryQuery, FetchHouseholdWorkflowTrackerHistoryQueryVariables>(FetchHouseholdWorkflowTrackerHistoryDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchHouseholdWorkflowTrackerHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchHouseholdWorkflowTrackerHistoryQuery, FetchHouseholdWorkflowTrackerHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchHouseholdWorkflowTrackerHistoryQuery, FetchHouseholdWorkflowTrackerHistoryQueryVariables>(FetchHouseholdWorkflowTrackerHistoryDocument, withFetchPolicyContext(options));
        }
export type FetchHouseholdWorkflowTrackerHistoryQueryHookResult = ReturnType<typeof useFetchHouseholdWorkflowTrackerHistoryQuery>;
export type FetchHouseholdWorkflowTrackerHistoryLazyQueryHookResult = ReturnType<typeof useFetchHouseholdWorkflowTrackerHistoryLazyQuery>;
export type FetchHouseholdWorkflowTrackerHistorySuspenseQueryHookResult = ReturnType<typeof useFetchHouseholdWorkflowTrackerHistorySuspenseQuery>;
export type FetchHouseholdWorkflowTrackerHistoryQueryResult = Apollo.QueryResult<FetchHouseholdWorkflowTrackerHistoryQuery, FetchHouseholdWorkflowTrackerHistoryQueryVariables>;
export const FetchHouseholdSetupHistoryDocument = gql`
    query FetchHouseholdSetupHistory($householdID: ID!) {
  extractionHistory: householdWorkflowTrackerHistory(
    householdID: $householdID
    first: 2
    filter: {kinds: [DOCUMENT_EXTRACTION]}
  ) {
    edges {
      node {
        ...HouseholdWorkflowTracker_WorkflowTracker
      }
    }
  }
  onboardingHistory: householdWorkflowTrackerHistory(
    householdID: $householdID
    first: 1
    filter: {kinds: [HOUSEHOLD_ONBOARDING_COMPLETION]}
  ) {
    edges {
      node {
        ...HouseholdWorkflowTracker_WorkflowTracker
      }
    }
  }
  presentationHistory: householdWorkflowTrackerHistory(
    householdID: $householdID
    first: 1
    filter: {kinds: [ESTATE_SNAPSHOT_GENERATION, PRESENTATION_TEMPLATE_PROMPT_GENERATION]}
  ) {
    edges {
      node {
        ...HouseholdWorkflowTracker_WorkflowTracker
      }
    }
  }
  validationHistory: householdWorkflowTrackerHistory(
    householdID: $householdID
    first: 1
    filter: {kinds: [VALIDATION_QUESTIONS]}
  ) {
    edges {
      node {
        ...HouseholdWorkflowTracker_WorkflowTracker
      }
    }
  }
}
    ${HouseholdWorkflowTracker_WorkflowTrackerFragmentDoc}`;

/**
 * __useFetchHouseholdSetupHistoryQuery__
 *
 * To run a query within a React component, call `useFetchHouseholdSetupHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHouseholdSetupHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHouseholdSetupHistoryQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useFetchHouseholdSetupHistoryQuery(baseOptions: Apollo.QueryHookOptions<FetchHouseholdSetupHistoryQuery, FetchHouseholdSetupHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchHouseholdSetupHistoryQuery, FetchHouseholdSetupHistoryQueryVariables>(FetchHouseholdSetupHistoryDocument, withFetchPolicyContext(options));
      }
export function useFetchHouseholdSetupHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchHouseholdSetupHistoryQuery, FetchHouseholdSetupHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchHouseholdSetupHistoryQuery, FetchHouseholdSetupHistoryQueryVariables>(FetchHouseholdSetupHistoryDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchHouseholdSetupHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchHouseholdSetupHistoryQuery, FetchHouseholdSetupHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchHouseholdSetupHistoryQuery, FetchHouseholdSetupHistoryQueryVariables>(FetchHouseholdSetupHistoryDocument, withFetchPolicyContext(options));
        }
export type FetchHouseholdSetupHistoryQueryHookResult = ReturnType<typeof useFetchHouseholdSetupHistoryQuery>;
export type FetchHouseholdSetupHistoryLazyQueryHookResult = ReturnType<typeof useFetchHouseholdSetupHistoryLazyQuery>;
export type FetchHouseholdSetupHistorySuspenseQueryHookResult = ReturnType<typeof useFetchHouseholdSetupHistorySuspenseQuery>;
export type FetchHouseholdSetupHistoryQueryResult = Apollo.QueryResult<FetchHouseholdSetupHistoryQuery, FetchHouseholdSetupHistoryQueryVariables>;
export const HouseholdWorkflowTrackerUpdatesDocument = gql`
    subscription HouseholdWorkflowTrackerUpdates($householdID: ID!) {
  householdWorkflowTrackerUpdates(householdID: $householdID) {
    ...HouseholdWorkflowTracker_WorkflowTracker
  }
}
    ${HouseholdWorkflowTracker_WorkflowTrackerFragmentDoc}`;

/**
 * __useHouseholdWorkflowTrackerUpdatesSubscription__
 *
 * To run a query within a React component, call `useHouseholdWorkflowTrackerUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdWorkflowTrackerUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdWorkflowTrackerUpdatesSubscription({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useHouseholdWorkflowTrackerUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<HouseholdWorkflowTrackerUpdatesSubscription, HouseholdWorkflowTrackerUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HouseholdWorkflowTrackerUpdatesSubscription, HouseholdWorkflowTrackerUpdatesSubscriptionVariables>(HouseholdWorkflowTrackerUpdatesDocument, withSubscriptionIgnoreResults(options));
      }
export type HouseholdWorkflowTrackerUpdatesSubscriptionHookResult = ReturnType<typeof useHouseholdWorkflowTrackerUpdatesSubscription>;
export type HouseholdWorkflowTrackerUpdatesSubscriptionResult = Apollo.SubscriptionResult<HouseholdWorkflowTrackerUpdatesSubscription>;